import React, {Fragment} from "react";
import CommonHeader from "../../components/Headers/CommonHeader";
import AddGroup from "../../components/Modal/AddGroup";
import ProtectedContent from "../../components/protectedContent";
import SafeView from "../../components/safeView/SafeView";
import PageURLContextProvider from "../../contexts/pageURLContext";
import {useDisclosure} from "../../hooks/useDisclosure";
import GroupsTable from "./groupsTable";

export const GroupComponent = () => {
  const {
    isOpen: isAddGroupOpen,
    onOpen: openAddGroup,
    onClose: closeAddGroup,
  } = useDisclosure();

  return (
    <SafeView>
      <ProtectedContent perms={["view_group"]} showFallback>
        <Fragment>
          <ProtectedContent perms={["add_group"]}>
            <CommonHeader
              content={"Add Group"}
              handleAddClick={openAddGroup}
              testID={"add_group"}
            />
          </ProtectedContent>
          {isAddGroupOpen && <AddGroup onCancel={closeAddGroup} open={isAddGroupOpen} />}
          <GroupsTable />
        </Fragment>
      </ProtectedContent>
    </SafeView>
  );
};

const GroupPage = () => {
  return (
    <PageURLContextProvider>
      <GroupComponent />
    </PageURLContextProvider>
  );
};

export default GroupPage;
